<template>
  <landing-page
    label="factSheet.alcoholConsumption"
    labelColor="#603813"
    descColor="#603813"
    :eggImgObj="{ componentName: 'factsheet', imgName: 'alcoholConsumptionLandingImage', imgFormat: 'png' }"
    :starBackgroundObj="{ componentName: 'shared', imgName: 'starGroupIconLightBrownRight', imgFormat: 'svg' }"
  />

  <div id="infoGroup" style="width: 60vw" class="fact-sheet-subpages pt-16 text-2xl font-jost space-y-12 m-auto pb-24">
    <div>
      <div class="font-bold text-description">{{ t("factSheet.healthEffects") }}</div>
      <div v-html="t('factSheet.healthEffectsDesc')" class="space-y-5" />
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.immediateEffects") }}</div>
      <div v-html="t('factSheet.immediateEffectsDesc')" class="space-y-5" />
      <table class="table-auto mt-5 w-full border border-black">
        <thead>
          <tr>
            <th colspan="2">{{ t("factSheet.immediateEffectsTableTitle") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="border border-black px-8 py-5">
              <ul class="list-disc bullet-big">
                <li v-for="(item, index) in factSheetStore.alcoholConsumptionImmediateEffectsList1" :key="'alcoholConsumptionImmediateSideEffects1' + index">{{ t(item.label) }}</li>
              </ul>
            </td>
            <td class="border border-black px-8 py-5">
              <ul class="list-disc bullet-big">
                <li v-for="(item, index) in factSheetStore.alcoholConsumptionImmediateEffectsList2" :key="'alcoholConsumptionImmediateSideEffects2' + index">{{ t(item.label) }}</li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.longTermEffects") }}</div>
      <div v-html="t('factSheet.longTermEffectsDesc')" class="space-y-5" />
      <table class="table-auto mt-5 w-full border border-black">
        <thead>
          <tr>
            <th class="border border-black">{{ t("factSheet.longTermEffectsTableTitle1") }}</th>
            <th>{{ t("factSheet.longTermEffectsTableTitle2") }}</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(item, index) in factSheetStore.alcoholConsumptionLongTermEffectsList" :key="'alcoholConsumptionLongTermEffectsBodyPart' + index">
            <tr>
              <td class="border border-black px-8 py-5 text-center">
                {{ t(item.label) }}
              </td>
              <td class="border border-black px-8 py-5">
                <ul class="list-disc bullet-big">
                  <li v-for="(listItem, index) in item.list" :key="'longTermEffectsConditions' + index">{{ t(listItem) }}</li>
                </ul>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.healthAdvices") }}</div>
      <div v-html="t('factSheet.healthAdvicesDesc')" class="space-y-5" />
      <div v-html="t('factSheet.healthAdvicesDescRef')" class="mt-5" />
    </div>
    <!-- Chinese Version -->
    <section class="!font-sanstc space-y-12">
      <div>
        <div class="font-bold text-description text-center text-4xl">{{ t("factSheetChinese.drinkingAlcohol") }}</div>
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.healthEffects") }}</div>
        <div v-html="t('factSheetChinese.healthEffectsDesc')" class="space-y-5" />
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.immediateEffects") }}</div>
        <div v-html="t('factSheetChinese.immediateEffectsDesc')" class="space-y-5" />
        <table class="table-auto mt-5 w-full border border-black">
          <thead>
            <tr>
              <th colspan="2">{{ t("factSheetChinese.immediateEffectsTableTitle") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="border border-black px-8 py-5">
                <ul class="list-disc bullet-big">
                  <li v-for="(item, index) in factSheetStore.alcoholConsumptionImmediateEffectsList1" :key="'immediateSideEffects1' + index">{{ t(item.label.replace("factSheet", "factSheetChinese")) }}</li>
                </ul>
              </td>
              <td class="border border-black px-8 py-5">
                <ul class="list-disc bullet-big">
                  <li v-for="(item, index) in factSheetStore.alcoholConsumptionImmediateEffectsList2" :key="'immediateSideEffects2' + index">{{ t(item.label.replace("factSheet", "factSheetChinese")) }}</li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.longTermEffects") }}</div>
        <div v-html="t('factSheetChinese.longTermEffectsDesc')" class="space-y-5" />
        <table class="table-auto mt-5 w-full border border-black">
          <thead>
            <tr>
              <th class="border border-black">{{ t("factSheetChinese.longTermEffectsTableTitle1") }}</th>
              <th>{{ t("factSheetChinese.longTermEffectsTableTitle2") }}</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(item, index) in factSheetStore.alcoholConsumptionLongTermEffectsList" :key="'longTermEffectsBodyPart' + index">
              <tr>
                <td class="border border-black px-8 py-5 text-center">
                  {{ t(item.label.replace("factSheet", "factSheetChinese")) }}
                </td>
                <td class="border border-black px-8 py-5">
                  <ul class="list-disc bullet-big">
                    <template v-for="(listItem, index) in item.list" :key="'longTermEffectsConditions' + index">
                      <li v-if="listItem != 'factSheet.deficiency'">{{ t(listItem.replace("factSheet", "factSheetChinese")) }}</li>
                    </template>
                  </ul>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.healthAdvices") }}</div>
        <div v-html="t('factSheetChinese.healthAdvicesDesc')" class="space-y-5" />
        <div v-html="t('factSheetChinese.healthAdvicesDescRef')" class="mt-5" />
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { useFactSheetStore } from "@/stores/factSheet";
import { useHeaderStore } from "@/stores/header";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

const factSheetStore = useFactSheetStore();
const headerStore = useHeaderStore();
const router = useRouter();
const { t, locale } = useI18n();

onMounted(async () => {
  headerStore.routerName = 'factsheet';
});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>